const normalizeValue = (value) => String(value || "").trim();

export const parseLegacySeatArea = (seatLabel) => {
  const match = normalizeValue(seatLabel).match(/^([a-z0-9]+)-(.+)$/i);
  if (!match) return "";
  return match[1].toUpperCase();
};

export const resolveStoredSeatArea = ({ seatArea, seatLabel, tierSeatAreas } = {}) => {
  const stored = normalizeValue(seatArea);
  if (stored) return stored;

  const legacy = parseLegacySeatArea(seatLabel);
  if (legacy) return legacy;

  const areas = Array.isArray(tierSeatAreas)
    ? tierSeatAreas.map(normalizeValue).filter(Boolean)
    : [];
  if (areas.length === 1) return areas[0];
  return "";
};

export const formatExactSection = (section, seatArea) => {
  const main = normalizeValue(section);
  const area = normalizeValue(seatArea);
  if (!area) return main;
  if (!main) return area;

  const areaUpper = area.toUpperCase();
  const mainUpper = main.toUpperCase();
  if (areaUpper === mainUpper) {
    return main;
  }
  if (areaUpper.startsWith(`${mainUpper} `) || areaUpper.startsWith(`${mainUpper}-`)) {
    return area;
  }
  if (areaUpper.includes(" - ")) {
    return area;
  }
  return `${main} ${area}`;
};

export const resolveCheckoutSeatArea = ({
  section,
  seatArea,
  seatLabel,
  fallbackPageLabel,
} = {}) => {
  const rawArea =
    resolveStoredSeatArea({ seatArea, seatLabel }) || normalizeValue(fallbackPageLabel);
  return formatExactSection(section, rawArea);
};

export const uniqueSeatKey = (ticketTierId, seatArea, seatLabel) =>
  `${ticketTierId}::${normalizeValue(seatArea)}::${normalizeValue(seatLabel)}`;
